// extracted by mini-css-extract-plugin
module.exports = {"PodcastsHero":"PodcastsHero_PodcastsHero__VxTCz","platformIcon":"PodcastsHero_platformIcon__XSUuJ"};